import { Check } from 'lucide-react'

import './browse.css'

export interface ToggleChip {
  id: string
  label: string
}

/**
 * Отбор «несколько из»: каждый чип включается и выключается отдельно. Включённый чип — рамка, жирность, галочка и
 * `aria-pressed`, а не только цвет. В отличие от `ChoiceChips` (выбор одного) состояние чипа не зависит от соседей.
 */
export function ToggleChips({
  label,
  items,
  active,
  onToggle,
}: {
  label: string
  items: readonly ToggleChip[]
  active: ReadonlySet<string>
  onToggle: (id: string) => void
}) {
  return (
    <div className="krp-chips krp-chips--row" role="group" aria-label={label}>
      {items.map((item) => {
        const pressed = active.has(item.id)
        return (
          <button key={item.id} type="button" className="krp-chip krp-chip--fixed" title={item.label} aria-pressed={pressed} onClick={() => onToggle(item.id)}>
            <Check size={14} aria-hidden="true" className="krp-chip__check" data-on={pressed} />
            <span className="krp-chip__text">{item.label}</span>
          </button>
        )
      })}
    </div>
  )
}
